import React, { useState, useContext } from "react";
import { Box, AppBar, Toolbar, Typography, IconButton, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { useTheme } from "@mui/material/styles";
import RoomList from "../component/RoomList";
import LoginDialog from "../component/LoginDialog";

const RoomListPage = () => {
  const navigate = useNavigate();
  const { storeId } = useParams();
  const theme = useTheme();
  const { user } = useContext(AuthContext);
  const [loginOpen, setLoginOpen] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("token") || null);

  const handleLoginOpen = () => setLoginOpen(true);
  const handleLoginClose = () => setLoginOpen(false);

  function logout() {
    localStorage.removeItem("token");
    setToken(null);
  }

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        minHeight: "100vh",
        width: "100%",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <AppBar
        position="static"
        elevation={0}
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* Back Button */}
          <IconButton
            edge="start"
            aria-label="back"
            onClick={() => navigate(-1)}
            sx={{ color: theme.palette.info.main }}
          >
            <ArrowBackIcon />
          </IconButton>

          {/* Page Title */}
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              textAlign: "center",
              fontWeight: 700,
              color: theme.palette.text.primary,
            }}
          >
            選擇場地
          </Typography>


        </Toolbar>
      </AppBar>

{/* ─── RoomList Section ───────────────────────────────────── */}
<Box
  sx={{
    px: 2,
    py: 3,
    display: "flex",
    justifyContent: "center",
  }}
>
  {token ? (
    <RoomList
      token={token}
      storeId={storeId}
      onSelectRoom={(tables, storeInfo) => {
        navigate(`/app/${storeId}/reserve`, {
          state: { tables, store: storeInfo },
        });
      }}
    />
  ) : (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
      }}
    >
      <Button
        variant="contained"
        sx={{
          width: "60%",
          height: "60px",
          fontSize: "18pt",
          fontWeight: "bold",
        }}
        onClick={() => setLoginOpen(true)}
      >
        登入以查看場地
      </Button>
    </Box>
  )}
</Box>


      {/* Login Dialog */}
      <LoginDialog
        openLogin={loginOpen}
        handleLoginClose={handleLoginClose}
        setToken={setToken}
      />
    </Box>
  );
};

export default RoomListPage;
